import { createContext, ReactNode, useContext } from "react";
import { IAgent } from "../models/agent";
import { useQuery } from "react-query";
import { getAgents } from "../api/agent";
import { useOrgContext } from "./org";
import { ObjectId } from "../models";

// context type
interface AgentContextType {
	agents?: IAgent[],
	isLoading: boolean,
	error: unknown,
	getAgentById: (id: ObjectId) => IAgent | undefined;
}

// context
export const AgentContext = createContext<AgentContextType | undefined>(undefined);

// provider
export const AgentProvider = ({ children }: { children: ReactNode }) => {
	// const [agent, setAgent] = useState<IAgent>();
	const {org} = useOrgContext();

	const {data: agents, isLoading, error} = useQuery({
		queryKey: ['Agents', org?.id],
		queryFn: () => getAgents(org!.id),
		enabled: !!org?.id
	});

	// Function to get an agent by ID
	const getAgentById = (id: ObjectId) => {
		return agents?.find(agent => agent.id === id);
	};

	return (
		<AgentContext.Provider value={{ agents, isLoading, error, getAgentById}}>
			{children}
		</AgentContext.Provider>
	)
}

// hook
export const useAgentContext = () => {
	const context = useContext(AgentContext);
	if (!context) {
		throw new Error("useAgentContext must be used within a AgentProvider");
	}
	return context;
}